var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { Type } from "class-transformer";
export class FastenEndpointDto {
}
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenEndpointDto.prototype, "id", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenEndpointDto.prototype, "platform_type", void 0);
export class FastenPortalDto {
}
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenPortalDto.prototype, "id", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenPortalDto.prototype, "name", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenPortalDto.prototype, "portal_website", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenEndpointDto),
    __metadata("design:type", Array)
], FastenPortalDto.prototype, "endpoints", void 0);
export class FastenIdentifiersDto {
}
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Object)
], FastenIdentifiersDto.prototype, "npi", void 0);
export class FastenBrandSourceDto {
}
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenBrandSourceDto.prototype, "id", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenIdentifiersDto),
    __metadata("design:type", FastenIdentifiersDto)
], FastenBrandSourceDto.prototype, "identifiers", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenBrandSourceDto.prototype, "last_updated", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenBrandSourceDto.prototype, "brand_website", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenBrandSourceDto.prototype, "name", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenBrandSourceDto.prototype, "sort_name", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], FastenBrandSourceDto.prototype, "aliases", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], FastenBrandSourceDto.prototype, "brand_ids", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenPortalDto),
    __metadata("design:type", Array)
], FastenBrandSourceDto.prototype, "portals", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], FastenBrandSourceDto.prototype, "hidden", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], FastenBrandSourceDto.prototype, "platform_type", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], FastenBrandSourceDto.prototype, "approved_apps", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], FastenBrandSourceDto.prototype, "locations", void 0);
export class FastenSearchHighlightDto {
}
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], FastenSearchHighlightDto.prototype, "aliases", void 0);
export class FastenSearchHitDto {
}
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenSearchHitDto.prototype, "_index", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenSearchHitDto.prototype, "_type", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenSearchHitDto.prototype, "_id", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Object)
], FastenSearchHitDto.prototype, "_score", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenBrandSourceDto),
    __metadata("design:type", FastenBrandSourceDto)
], FastenSearchHitDto.prototype, "_source", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenSearchHighlightDto),
    __metadata("design:type", FastenSearchHighlightDto)
], FastenSearchHitDto.prototype, "highlight", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], FastenSearchHitDto.prototype, "sort", void 0);
export class FastenHitsTotalDto {
}
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], FastenHitsTotalDto.prototype, "value", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenHitsTotalDto.prototype, "relation", void 0);
export class FastenHitsContainerDto {
}
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenHitsTotalDto),
    __metadata("design:type", FastenHitsTotalDto)
], FastenHitsContainerDto.prototype, "total", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Object)
], FastenHitsContainerDto.prototype, "max_score", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenSearchHitDto),
    __metadata("design:type", Array)
], FastenHitsContainerDto.prototype, "hits", void 0);
export class FastenShardsDto {
}
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], FastenShardsDto.prototype, "total", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], FastenShardsDto.prototype, "successful", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], FastenShardsDto.prototype, "skipped", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], FastenShardsDto.prototype, "failed", void 0);
export class FastenAggregationBucketDto {
}
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenAggregationBucketDto.prototype, "key", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], FastenAggregationBucketDto.prototype, "doc_count", void 0);
export class FastenAggregationDto {
}
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], FastenAggregationDto.prototype, "doc_count_error_upper_bound", void 0);
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], FastenAggregationDto.prototype, "sum_other_doc_count", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenAggregationBucketDto),
    __metadata("design:type", Array)
], FastenAggregationDto.prototype, "buckets", void 0);
export class FastenAggregationsDto {
}
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenAggregationDto),
    __metadata("design:type", FastenAggregationDto)
], FastenAggregationsDto.prototype, "by_platform_type", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenAggregationDto),
    __metadata("design:type", FastenAggregationDto)
], FastenAggregationsDto.prototype, "by_category", void 0);
export class FastenSearchDataDto {
}
__decorate([
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], FastenSearchDataDto.prototype, "took", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], FastenSearchDataDto.prototype, "timed_out", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenShardsDto),
    __metadata("design:type", FastenShardsDto)
], FastenSearchDataDto.prototype, "_shards", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenHitsContainerDto),
    __metadata("design:type", FastenHitsContainerDto)
], FastenSearchDataDto.prototype, "hits", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenAggregationsDto),
    __metadata("design:type", FastenAggregationsDto)
], FastenSearchDataDto.prototype, "aggregations", void 0);
export class FastenSearchResponseDto {
}
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], FastenSearchResponseDto.prototype, "success", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenSearchDataDto),
    __metadata("design:type", FastenSearchDataDto)
], FastenSearchResponseDto.prototype, "data", void 0);
export class FastenSearchResult {
}
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenSearchResult.prototype, "id", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenSearchResult.prototype, "name", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], FastenSearchResult.prototype, "sortName", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], FastenSearchResult.prototype, "brandIds", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenPortalDto),
    __metadata("design:type", Array)
], FastenSearchResult.prototype, "portals", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], FastenSearchResult.prototype, "logoUrl", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], FastenSearchResult.prototype, "locations", void 0);
export function transformToSearchResults(response, environment) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const hits = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.hits) === null || _b === void 0 ? void 0 : _b.hits;
    const totalHits = (_f = (_e = (_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.hits) === null || _d === void 0 ? void 0 : _d.total) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : 0;
    if (!response.success || !hits || hits.length === 0) {
        console.warn("Failed to transform fasten search results despite a successful response");
        return { results: [], nextCursor: null, totalHits };
    }
    const results = hits.map((hit) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return ({
            id: (_a = hit._source) === null || _a === void 0 ? void 0 : _a.id,
            name: (_b = hit._source) === null || _b === void 0 ? void 0 : _b.name,
            sortName: (_c = hit._source) === null || _c === void 0 ? void 0 : _c.sort_name,
            portals: (_d = hit._source) === null || _d === void 0 ? void 0 : _d.portals,
            brandIds: (_e = hit._source) === null || _e === void 0 ? void 0 : _e.brand_ids,
            logoUrl: ((_g = (_f = hit._source) === null || _f === void 0 ? void 0 : _f.brand_ids) === null || _g === void 0 ? void 0 : _g[0]) ? `${environment.FASTEN_LOGO_BASE_URL}/${hit._source.brand_ids[0]}.png` : null,
            locations: (_h = hit._source) === null || _h === void 0 ? void 0 : _h.locations,
        });
    });
    const lastHit = hits[hits.length - 1];
    const nextCursor = (_h = (_g = lastHit === null || lastHit === void 0 ? void 0 : lastHit.sort) === null || _g === void 0 ? void 0 : _g.map((value) => String(value))) !== null && _h !== void 0 ? _h : null;
    return { results, nextCursor, totalHits };
}
